var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialTiktok = function SvgSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M433.985 212.84a196.976 196.976 0 0 1-115.126-36.806v167.593a152.434 152.434 0 0 1-99.02 142.71A152.431 152.431 0 0 1 32.376 271.014a152.426 152.426 0 0 1 154.984-78.429v84.294a69.972 69.972 0 0 0-77.412 108.145 69.973 69.973 0 0 0 126.39-41.397V16h82.521a113.544 113.544 0 0 0 1.744 20.79 114.569 114.569 0 0 0 50.553 75.225 113.866 113.866 0 0 0 62.829 18.886v81.939Z"
  })));
};
export default SvgSocialTiktok;